import tastyBites from './images/tastyBites.png'
import memeMuseum from './images/memeMuseum.png'
import macMiller from './images/macMiller.png'
import Hangman from './images/Hangman.png'
import myTrails from './images/mytrails.png'
import Travlers from './images/travlersClub.png'
import caiaSolutions from './images/caiaSolutions.png'

const project = [
    // {
    //     id : 1,
    //     title : 'PROJECTS COMING SOON!',
    //     date : '',
    //     link : "",
    //     preview : 'IN THE MEAN TIME, YOU CAN CHECK OUT SOME LABS IN MY GITHUB!',
    //     image : ''
    // },
    {
        id : 1,
        title : 'TASTY BITES',
        date : 'JUNE 29, 2023',
        link : "https://youtu.be/b3e1xlt98xk",
        githubLink : "https://github.com/BOUCKY/Phase-2-Project",
        preview : 'A PLACE TO BROWSE RECIPES, ADD SOME TO YOUR FAVORITES, AND EVEN ADD YOUR OWN.',
        image : tastyBites
    },
    {
        id : 2,
        title : 'MUSEUM OF MEMES',
        date : 'JUNE 9, 2023',
        link : "https://museum-of-memes.netlify.app/",
        githubLink : "https://github.com/JerryWu1998/phase-1-project",
        preview : 'CREATE YOUR OWN MEMES GIVEN THE TEMPLATE AND ADD THEM TO THE MUSEUM!',
        image : memeMuseum
    },
    {
        id : 3,
        title : 'MAC MILLER',
        date : 'APRIL 28, 2021',
        link : "https://alexisbou116.github.io/",
        githubLink : "https://alexisbou116.github.io/",
        preview : 'A TRIBUTE TO MAC MILLER, AND MY VERY FIRST PROJECT',
        image : macMiller
    },
    {
        id : 4,
        title : 'CLI HANGMAN',
        date : 'JULY 21, 2023',
        link : "https://youtu.be/ZRW7Rf-LeEg",
        githubLink : "https://github.com/BOUCKY/Project-3",
        preview : 'A FUN COMMAND LINE HANGMAN GAME!',
        image : Hangman
    },
    {
        id : 5,
        title : 'MY TRAILS',
        date : 'AUGUST 11, 2023',
        link : "https://youtu.be/ZVYZ9F0Z5VI",
        githubLink : "https://github.com/bonbongiraffe/mytrails",
        preview : 'A HIKING APP TO POST AND VIEW TRAILS.',
        image : myTrails
    },
    {
        id : 6,
        title : "TRAVLER'S CLUB",
        date : 'AUGUST 25, 2023',
        link : "https://youtu.be/UlrMBCGLmno",
        githubLink : "https://github.com/BOUCKY/final_project",
        preview : 'BROWSE VARIOUS DESTINATIONS AND POST YOUR TRAVELS!',
        image : Travlers
    },
    {
        id : 7,
        title : "CAIASOFT®",
        date : 'APRIL 15, 2025',
        link : "https://www.caia-solutions.com/",
        githubLink : "#",
        preview : 'COLLECTIONS ARE INFINTIE; SPACE IS FINITE',
        image : caiaSolutions
    }
]

export default project
